<template>
  <v-form>
    <gg-text-field
      label="Name"
      name="Name"
      placeholder="Valid zone name"
      v-model="model.name"
      v-validate="rules.name"
      :error-messages="errors.collect('Name')"
      @input="sendData"></gg-text-field>
    <gg-text-field
      label="TTL"
      name="TTL"
      placeholder="14400"
      v-model="model.ttl"
      v-validate="rules.ttl"
      :error-messages="errors.collect('TTL')"
      @input="sendData"></gg-text-field>
    <gg-text-field
      label="Priority"
      name="Priority"
      type="number"
      placeholder="Integer"
      v-model="model.priority"
      v-validate="rules.priority"
      :error-messages="errors.collect('Priority')"
      @input="sendData"></gg-text-field>
    <gg-text-field
      label="Weight"
      name="Weight"
      type="number"
      placeholder="Integer"
      v-model="model.weight"
      v-validate="rules.weight"
      :error-messages="errors.collect('Weight')"
      @input="sendData"></gg-text-field>
    <gg-text-field
      label="Port"
      name="Port"
      type="number"
      placeholder="Port number"
      v-model="model.port"
      v-validate="rules.port"
      :error-messages="errors.collect('Port')"
      @input="sendData"></gg-text-field>
    <gg-text-field
      label="Target"
      name="Target"
      placeholder="Valid zone name"
      v-model="model.target"
      v-validate="rules.url"
      :error-messages="errors.collect('Target')"
      @input="sendData"></gg-text-field>
  </v-form>
</template>

<script>
import { ZoneRecord } from '@/mixins/ZoneRecord'

export default {
  name: 'SRVRecordForm',
  mixins: [ZoneRecord],
  inject: ['parentValidator'],
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      model: {
        name: '',
        ttl: '14400',
        priority: '',
        weight: '',
        target: '',
        port: ''
      },
      rules: {
        name: { required: true },
        ttl: { required: true, numeric: true },
        priority: { required: true, numeric: true },
        weight: { required: true, numeric: true },
        port: { required: true, numeric: true },
        url: { required: true, url: true }
      }
    }
  },
  methods: {
    fillEditData () {
      for (let key in this.item) {
        if (this.item.hasOwnProperty(key)) {
          this.model[key] = this.item[key]
        }
      }
    }
  },
  created () {
    this.$validator = this.parentValidator
    if (this.edit) {
      this.fillEditData()
    }
    this.sendData()
  }
}
</script>
